import React from 'react';

const styles = {
    container: {
        fontFamily: 'Arial, sans-serif',
        padding: '20px',
        lineHeight: '1.6',
    },
    title: {
        color: '#333',
    },
    subTitle: {
        color: '#666',
    },
    paragraph: {
        marginBottom: '15px',
    },
    listItem: {
        marginBottom: '10px',
    },
};

function PrivacyPolicy() {
    return (
        <div style={styles.container}>
            <h1 style={styles.title}>Personvernerklæring for Fasia Trening</h1>
            <p style={styles.paragraph}>
                Denne personvernerklæringen forklarer hvordan Fasia Trening ("vi", "oss", "vår") samler inn, bruker, deler og beskytter dine personopplysninger når du bruker vår app, Fasia Trening ("Appen").
            </p>

            <h2 style={styles.subTitle}>1. Informasjon vi samler inn</h2>
            <p style={styles.paragraph}>
                Vi samler inn følgende personlige opplysninger fra deg:
            </p>
            <ul>
                <li style={styles.listItem}>Navn</li>
                <li style={styles.listItem}>E-postadresse</li>
                <li style={styles.listItem}>Treningsdata (inkludert antall treninger, type treninger med antall repetisjoner og vekt)</li>
                <li style={styles.listItem}>I noen tilfeller din vurdering av eget energinivå (dersom behandler har gitt deg dette programmet)</li>
                <li style={styles.listItem}>I noen tilfeller din vurdering av søvnkvalitet (dersom behandler har gitt deg dette programmet)</li>
                <li style={styles.listItem}>I noen tilfeller din vurdering av smerte (dersom behandler har gitt deg dette programmet)</li>
            </ul>

            <h2 style={styles.subTitle}>2. Hvordan vi bruker din informasjon</h2>
            <p style={styles.paragraph}>
                Vi bruker din informasjon for å:
            </p>
            <ul>
                <li style={styles.listItem}>Levere, forbedre og personalisere vår App</li>
                <li style={styles.listItem}>Lage statistikker og analyser for at behandler skal følge med på din utvikling, og for å dele med deg</li>
                <li style={styles.listItem}>Kommunisere med deg, for eksempel for å sende deg forslag om endringer i program, eller oppdateringer om Appen</li>
            </ul>

            <h2 style={styles.subTitle}>3. Hvordan vi deler din informasjon</h2>
            <p style={styles.paragraph}>
                Vi deler ikke din personlige informasjon med tredjeparter, med unntak av vår databehandler Google Firebase, som hjelper oss med å lagre og administrere din informasjon.
            </p>

            <h2 style={styles.subTitle}>4. Dine rettigheter</h2>
            <p style={styles.paragraph}>
                I samsvar med GDPR har du rett til å:
            </p>
            <ul>
                <li style={styles.listItem}>Be om tilgang til, rettelse eller sletting av dine personopplysninger</li>
                <li style={styles.listItem}>Begrense behandlingen av dine personopplysninger</li>
                <li style={styles.listItem}>Motsette deg behandlingen av dine personopplysninger</li>
                <li style={styles.listItem}>Be om dataportabilitet</li>
            </ul>

            <h2 style={styles.subTitle}>5. Hvordan vi beskytter din informasjon</h2>
            <p style={styles.paragraph}>
                Vi tar din sikkerhet på alvor og implementerer passende tekniske og organisatoriske tiltak for å beskytte dine personopplysninger mot uautorisert tilgang, bruk eller avsløring.
            </p>

            <h2 style={styles.subTitle}>6. Endringer i vår personvernerklæring</h2>
            <p style={styles.paragraph}>
                Vi kan oppdatere vår personvernerklæring fra tid til annen. Du vil bli varslet om eventuelle vesentlige endringer.
            </p>

            <h2 style={styles.subTitle}>7. Kontakt oss</h2>
            <p style={styles.paragraph}>
                Hvis du har spørsmål om denne personvernpolitikken, eller hvis du ønsker å utøve noen av dine rettigheter, vennligst kontakt din behandler.
            </p>

            <p style={styles.paragraph}>
                Dato for siste oppdatering: 7.7.2023
            </p>
        </div>
    );
}

export default PrivacyPolicy;
